import AccountMenu from './AccountMenu';
import { connect } from 'react-redux';
import {
  accountViewMenuOptionSel,
  accountViewActions
} from 'src/store/modules/accountview';
import { userDataSel } from 'src/store/modules/user';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: any) => {
  return {
    selected: accountViewMenuOptionSel(state),
    userData: userDataSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onSelect: (selected: string) =>
    dispatch(accountViewActions.setMenuOption(selected))
});

export const pureComponent = AccountMenu;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(AccountMenu));

interface IDispatchFromProps {
  onSelect(selected: string): void;
}
